import { FC } from 'react'
import arrayMutators from 'final-form-arrays'
import { AnyObject, Form as FinalForm } from 'react-final-form'
import { Button, Grid, makeStyles, Paper } from '@material-ui/core'

import useTranslate from '../../../i18n/useTranslate'

import Approve from './Approve'
import Information from './Infomation'
import { FormT } from '../../../services/um/useApproveExResearcher'

type Submit = (
    event?: Partial<Pick<React.SyntheticEvent, 'preventDefault' | 'stopPropagation'>>,
) => Promise<AnyObject | undefined> | undefined
interface FormProps {
    onSubmit: (values: FormT) => void
    onBack: () => void
    initial: FormT
}

const Form: FC<FormProps> = ({ onSubmit, onBack, initial }) => {
    const translate = useTranslate()
    const classes = useStyles()

    const renderApproveForm = () => {
        if (initial.status === '1') {
            return (
                <Grid item xs={12}>
                    <Approve />
                </Grid>
            )
        }
    }

    const renderButton = (handleSubmit: Submit) => {
        if (initial.status === '1') {
            return (
                <Button
                    size={'large'}
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    className={classes.saveButton}
                >
                    {translate.get('BUTTON.SAVE')}
                </Button>
            )
        }
    }

    return (
        <>
            <FinalForm
                onSubmit={onSubmit}
                initialValues={{ ...initial, uploadFile: initial.files, langReason: 'th' }}
                mutators={{
                    ...arrayMutators,
                }}
            >
                {({ handleSubmit }) => {
                    return (
                        <Grid container>
                            <Paper className={classes.paper}>
                                <Grid container spacing={2} className={classes.container}>
                                    <Grid item xs={12}>
                                        <Information initFiles={initial.files} />
                                    </Grid>
                                    {renderApproveForm()}
                                </Grid>
                            </Paper>

                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            variant="contained"
                                            onClick={onBack}
                                            className={classes.cancelButton}
                                        >
                                            {translate.get('BUTTON.CANCEL')}
                                        </Button>
                                    </Grid>
                                    <Grid item>{renderButton(handleSubmit)}</Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    paper: {
        width: '100%',
        margin: '1rem 0px 1.5rem',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
        },
    },
    container: {
        padding: '1.5rem',
    },
    containerBT: {
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
    },
    saveButton: {
        border: 'solid 1px #db5f8e',
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))

export default Form
